import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './css/style.scss';

class ArticleGallery extends PureComponent {

  static propTypes = {
    img: PropTypes.string.isRequired,
    classStyle: PropTypes.string
  }

  render() {
    const { img, classStyle } = this.props;

    return (
      <div className={`entry-gallery ${classStyle}`}>
        <img className="entry-gallery-img" src={img} alt={`Изображение на статия`} />
      </div>

    );
  }
}

export default ArticleGallery;